(function () {
  'use strict';

  function lionApi() {
    return window.loyaltylion || window.lion || null;
  }

  function lionCustomer() {
    var lion = lionApi();
    if (!lion) return null;
    return lion.customer || lion.currentCustomer || (lion.state && lion.state.customer) || null;
  }

  function lionReferralUrl() {
    var customer = lionCustomer();
    if (!customer) return '';
    var nested = customer.referral || {};
    return (
      customer.referralUrl ||
      customer.referral_url ||
      customer.referralURL ||
      nested.url ||
      nested.link ||
      nested.referralUrl ||
      ''
    );
  }

  function componentUrl(root) {
    var el = root.querySelector('[data-lion-referral-url]');
    return el ? String(el.textContent || el.innerText || '').trim() : '';
  }

  function currentUrl(root) {
    return componentUrl(root) || lionReferralUrl() || root.getAttribute('data-referral-url') || '';
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.top = '0';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus();
      input.select();
      try {
        if (document.execCommand('copy')) resolve();
        else reject(new Error('copy failed'));
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(input);
      }
    });
  }

  function setStatus(root, message, isError) {
    var status = root.querySelector('[data-privileges-status]');
    if (!status) return;
    if (!message) {
      status.hidden = true;
      status.textContent = '';
      return;
    }
    status.hidden = false;
    status.textContent = message;
    status.classList.toggle('is-error', !!isError);
  }

  function applyUrl(root, url) {
    if (!url) return false;

    root.setAttribute('data-has-url', 'true');
    root.setAttribute('data-referral-url', url);

    var lionEl = root.querySelector('[data-lion-referral-url]');
    if (lionEl && !String(lionEl.textContent || '').trim()) {
      lionEl.textContent = url;
    }

    setStatus(root, '');
    return true;
  }

  function refresh(root) {
    return applyUrl(root, currentUrl(root));
  }

  function markTimedOut(root) {
    setStatus(root, 'Your invitation is not ready yet. Refresh the page in a moment.', false);
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var lionEl = root.querySelector('[data-lion-referral-url]');
    var loggedIn = root.getAttribute('data-logged-in') === 'true';

    refresh(root);

    if (lionEl) {
      var observer = new MutationObserver(function () {
        refresh(root);
      });
      observer.observe(lionEl, { childList: true, characterData: true, subtree: true });
    }

    function whenLionReady(callback) {
      var lion = lionApi();
      if (lion && typeof lion.on === 'function') {
        lion.on('ready', callback);
        return;
      }

      var tries = 0;
      var wait = window.setInterval(function () {
        tries += 1;
        var later = lionApi();
        if (later && typeof later.on === 'function') {
          window.clearInterval(wait);
          later.on('ready', callback);
        } else if (tries >= 25) {
          window.clearInterval(wait);
          callback();
        }
      }, 200);
    }

    if (loggedIn && !currentUrl(root)) {
      whenLionReady(function () {
        refresh(root);
      });

      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (refresh(root) || attempts >= 15) {
          window.clearInterval(timer);
          if (!currentUrl(root)) markTimedOut(root);
        }
      }, 300);
    }

    function lionModalOpen() {
      return !!document.querySelector(
        '#loyaltylion [class*="modal"], .lion-isolator [class*="modal"], [class*="lion-referral-modal"]'
      );
    }

    function shareInvitation(url) {
      if (url && navigator.share) {
        navigator.share({
          title: 'Harper Kendall Privileges',
          text: 'Give them £30 towards their first Harper Kendall order.',
          url: url
        }).catch(function () { /* cancelled */ });
        return;
      }

      if (url) {
        copyText(url).then(function () {
          setStatus(root, 'Invitation copied. Paste it into a message to share it.', false);
        }).catch(function () {
          setStatus(root, 'Your invitation: ' + url, false);
        });
        return;
      }

      setStatus(root, 'Your invitation is still loading. Try again in a moment.', true);
    }

    var shareBtn = root.querySelector('[data-privileges-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function (event) {
        var url = currentUrl(root);
        var lion = lionApi();

        if (lion && lion.isLoyaltyLion) {
          window.setTimeout(function () {
            if (!lionModalOpen()) shareInvitation(url);
          }, 350);
          return;
        }

        event.preventDefault();
        shareInvitation(url);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-privileges-referral]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
